import { __ } from '@wordpress/i18n';

const Header = ( props ) => {
	return (
		<>
			<div className="re-esp-settings-header" key="settings-header">
				<div className="re-esp-settings-header__logo">Re/ESP</div>

				<div className="re-esp-settings-header__links"></div>
			</div>

			<div className="re-esp-heading">
				<h1>Settings</h1>
				<p>
					{ __(
						'Connect your Beehiiv account to import your content to WordPress.',
						're-ESP'
					) }
				</p>
			</div>
		</>
	);
};

export default Header;
